module.exports = __webpack_public_path__ + "static/media/comment.25341ac8.svg";